import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet, Link  } from '@react-pdf/renderer';
import logo from '../../../../assets/img/logo/apex.png';
import byte from '../../../../assets/img/footer/footerLogo.png'

const styles = StyleSheet.create({
  title:{fontSize: 14, textAlign: 'left', marginBottom: 1 , marginTop:3, color:'#121275'},
  subHeader: { fontSize: 12, marginBottom: 1 , marginTop:5, textAlign: 'center', color:'#121275'},
  timeCardSubHeader: { fontSize: 12, marginBottom: 5, textAlign: 'center', backgroundColor:'#121275', color:'#ffffff'},
  invoiceSubHeader: {fontSize: 12, textAlign: 'center', backgroundColor:'#121275', color:'#ffffff', maxHeight:10},
  text: { fontSize: 12, marginBottom: 3, padding: 5, display:'flex'},
  timecardText : { fontSize: 12, marginBottom: 3,  marginTop: 3, padding: 5, display:'flex', textAlign:'center'},
  total: {fontSize: 14, marginBottom: 5, marginTop:15, color:'#121275', textAlign:'right', marginRight:70},
  discount: {fontSize: 12, marginBottom: 5, marginTop:2, color:'red', textAlign:'right', marginRight:65},
  final: {fontSize: 14, marginBottom: 5, marginTop:15, color:'darkblue', textAlign:'right', marginRight:60},
  imageHeader: {
    //flexDirection: 'row',
    //justifyContent: 'space-between',
    //alignItems: 'center',
    //padding: 2,
    //borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop:1

  },
  link: {
    fontSize: 10,
    textAlign: 'center',
     color: 'blue', // You can customize the link color
    textDecoration: 'underline', // Add underline for classic link appearance
  },
  footerImage: {
    //flexDirection: 'row',
    //justifyContent: 'space-between',
    //alignItems: 'center',
    //padding: 2,
    //borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems:'flex-start',
    margin:10,
    marginTop:1,
  },
  footerLogo: {
    width: 90,
    height: 40,
    opacity: 0.8,
    marginTop: 1,
  },
  footerText: { margin:15,fontSize: 6, display:'flex', color:'#7c7c7c'},
  logo: {
    width: 140,
    height: 50,
    objectFit: 'contain',
  },
 page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
  },
  section: {
    width: '80%',
   marginLeft: 50,
   marginBottom: 20,
   marginTop:20,
   padding: 5,
   flexGrow: 1,
   // Mimic grid-cols layout using flexbox
   flexDirection: 'row',
   flexWrap: 'wrap',
   justifyContent: 'space-between',
   borderRadius: 5, // Apply border-radius here
   overflow: 'hidden',
   border: '1pt solid rgb(3, 13, 100)',
   
  },
    headerContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    padding: 5,
    backgroundColor:'#121275',
    color:'#ffffff',
    textAlign: 'center',
  },
  headerText: {
    fontSize: 12,
    fontWeight: 'bold',
  },
   content: {
    marginTop: 20, // Adjust to leave space for the header
  },
  container: {
    borderRadius: 8, // Apply border-radius here
    overflow: 'hidden',
    border: '1pt solid #ccc',
    paddingBottom: 60,
    marginBottom: 45,
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5
  },
  column: {
    width: '50%', // Approx. 2 columns
    marginBottom: 1,
    marginTop:20,
    fontSize:12,
    padding: 1,
  },
  table: {
    display: 'flex',
    width: 'auto',
    marginBottom: 10
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    border: '1pt solid #ccc',
  },
  timecardTtable: {
    display: 'flex',
    width: 'auto',
    marginBottom: 10,
    marginTop:10
  },
   timeCardTableRow: {
    margin: 'auto',
    flexDirection: 'row',
   // borderBottom: '1pt solid #ccc',
  },
  tableColHeader: {
   /*  width: '20%',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderColor: '#eee',
    padding: 8,
    backgroundColor: '#ffffff', */
     width: '20%',
    paddingTop: '10px',
    paddingBottom: '10px',
    backgroundColor:'#121275',
    textAlign:'left',
    color:'#ffffff',
    padding: 1,

  },

  timeCardColHeader: {
    width: '20%',
    paddingTop: '10px',
    paddingBottom: '10px',
    backgroundColor:'#f9f9f9',
    textAlign:'left',
    color:'#7c7c7c',
    padding: 1,

  },
  timeCardTableCol: {
    width: '20%',
    textAlign:'left',
    padding: 0,
  },
  tableCol: {
    width: '20%',
    padding: 0,
  },
  tableCell: {
    margin: 5,
    marginTop: 3,
    marginBottom: 3,
    fontSize: 10,
    textAlign:'left'
  },
  tableCellHeader: { margin: 5, fontSize: 12, fontWeight: 'bold' },
    stripedRow: {
    backgroundColor: '#f2f2f2',
  },
  pageNumbers: {
    position: 'absolute',
     bottom: 20,
     left: 0,
     right: 0,
     textAlign: 'center',
     fontSize: 10,
     color: 'gray',
  },
    horizontalLine: {
    borderBottomColor: '#f2f2f2', // Color of the line
    borderBottomWidth: 1,        // Thickness of the line
    marginBottom: 5,            // Space below the line
    marginTop: 10,               // Space above the line
  },
   footer: {
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 10,
        color: 'grey',
        borderTop: '1px solid #C4C4C4',
        paddingTop: 8,
   },
  header: {
        position: 'absolute',
        top: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 12,
        color: 'grey',
        borderBottom: '1px solid #C4C4C4',
        paddingBottom: 5,
      }, 
   alignLeft: {
     textAlign: 'left',
   },
   alignCenter: {
     textAlign: 'center',
   },
   alignRight: {
     textAlign: 'right',
   },    
   
});

interface InvoiceItem {
  studentName: string;
  major: string;
  totalHours: number;
  ratePerHour: number;
  subtotal: number;
}

interface TimecardEntry {
  creationDate:Date |null;
  studentId: string;
  fullName: string;
  firstName:string;
  lastName:string;
  grade:string;
  major: string;
  date: Date |null;
  hours: number;
  hourlyRate: number;
  email:string;
  id:string;
}

interface MyDocumentProps {
  data: InvoiceItem[];
  invoiceFor: string,
  incoiceNo: number,
  total:number; 
  timecard: TimecardEntry[];
  discount:number;
  finalAmount:string;
}


 const InvoicePdf :React.FC<MyDocumentProps> = ({ data, invoiceFor, incoiceNo, total, timecard, discount, finalAmount }) => {
const formatTimestamp = (unixTimestamp: number): string => {
    // Convert seconds to milliseconds for the Date object

    const date = new Date(unixTimestamp * 1000); 

    // Use toLocaleString to get a human-readable, locale-specific format
    const options: Intl.DateTimeFormatOptions = {
      month: '2-digit',
      day: '2-digit',
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
   const formattedDate = formatter.format(date);
    return formattedDate;
  };
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.container}>
          <View style={styles.imageHeader}><Image src={logo} style={styles.logo} /></View>
           <Link src="https://apexlearningsolutions.vercel.app/" style={styles.link}>www.apexlearningsolutions.vercel.app</Link>
          <View >
          <View style={styles.table}>
          <View style={styles.section}>
            <View style={styles.headerContainer}>
                 <Text style={styles.headerText}>Invoice Details</Text>
            </View>
            <View style={styles.column}>
              <Text style={styles.subHeader}> Name: {data[0].studentName}</Text>
           </View>
           <View style={styles.column}>
              <Text style={styles.subHeader}> Invoice Date: {new Date().toLocaleDateString()}</Text>
           </View>
           <View style={styles.column}>
              <Text style={styles.subHeader}>Invoice For: {invoiceFor}</Text>
           </View>
           <View style={styles.column}>
              <Text style={styles.subHeader}>Invoice #: Apex 0{incoiceNo}</Text>
           </View>
    
          </View>
            <View style={styles.tableRow}>
              <View style={styles.tableColHeader}><Text style={styles.tableCell}>Major</Text></View>
              <View style={styles.tableColHeader}><Text style={styles.tableCell}>Total Hours</Text></View>
              <View style={styles.tableColHeader}><Text style={styles.tableCell}>Rate Per Hour</Text></View>
              <View style={styles.tableColHeader}><Text style={styles.tableCell}>SubTotal</Text></View>
            </View>

             {/* Table Rows */}
          {data.map((item, index) => (
            <View  key={index} 
             style={
              index % 2 === 1
                ? { ...styles.tableRow, ...styles.stripedRow }
                : styles.tableRow
            }>
              <View style={styles.tableCol}> 
                 <Text style={styles.tableCell}>{item.major}</Text>
              </View>
              <View style={styles.tableCol}>
                 <Text style={styles.tableCell}>{item.totalHours}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>${item.ratePerHour}</Text>
              </View>
              <View style={styles.tableCol}>  
                 <Text style={styles.tableCell}>${item.subtotal}</Text>
               </View>  
            </View>
          ))}
          <View>
           <Text style={styles.total}>Total Amount : ${total}</Text> 
          </View>
          
           <View  style={styles.horizontalLine}>
           {(() => {
              if (discount > 0) {
              return   <Text style={styles.discount}>Discount  : {discount} %</Text> ;
             } 
            })()}
         
          </View> 
           <View>
               {(() => {
              if (discount > 0) {
              return    <Text style={styles.final}>Final Amount  : ${finalAmount}</Text>  ;
             } 
            })()}
         
          
          </View> 
         </View>
        </View>
      </View> 
      <View style={styles.footer} fixed>
        <Text
            style={styles.pageNumbers}
            render={({ pageNumber, totalPages }) => (
              `${pageNumber} / ${totalPages}`
            )}
           /> 
     </View> 
   </Page>
   <Page size="A4" style={styles.page}>
      <View style={styles.container}>
         <View style={styles.timeCardSubHeader}>
           <Text style={styles.timecardText}>Timecard Details</Text>
         </View>
          <View style={styles.timecardTtable}>
            <View style={styles.timeCardTableRow}>
              <View style={styles.timeCardColHeader}><Text style={styles.tableCellHeader}>Item </Text></View>
              <View style={styles.timeCardColHeader}><Text style={styles.tableCellHeader}>Date</Text></View>
              <View style={styles.timeCardColHeader}><Text style={styles.tableCellHeader}>Major</Text></View>
              <View style={styles.timeCardColHeader}><Text style={styles.tableCellHeader}>Total Hours</Text></View>
              <View style={styles.timeCardColHeader}><Text style={styles.tableCellHeader}>Rate Per Hour</Text></View>
            </View>
            {timecard.map((entry, index) => (
              <View style={styles.timeCardTableRow} key={index}>
                <View style={styles.timeCardTableCol}><Text style={styles.tableCell}>{index+1}</Text></View>
                <View style={styles.timeCardTableCol}><Text style={styles.tableCell}>{`${formatTimestamp(Number(entry.date))}`}/{invoiceFor.substring(3)}</Text></View>
                <View style={styles.timeCardTableCol}><Text style={styles.tableCell}>{entry.major}</Text></View>
                <View style={styles.timeCardTableCol}><Text style={[styles.tableCell,styles.alignCenter]}>{entry.hours}</Text></View>
                <View style={styles.timeCardTableCol}><Text style={[styles.tableCell,styles.alignCenter]}>${entry.hourlyRate}</Text></View> 
              </View>
            ))} 
          </View>
        </View>
         <View style={styles.footer} fixed>
        <Text
            style={styles.pageNumbers}
            render={({ pageNumber, totalPages }) => (
              `${pageNumber} / ${totalPages}`
            )}
           /> 
          <View style={styles.footerImage}>
            <Image src={byte} style={styles.footerLogo} />
          </View>
          </View> 
          
      </Page>
    </Document>
  );
}; 

export default InvoicePdf;